import { render, staticRenderFns } from "./Zwembaden.vue?vue&type=template&id=92773164&scoped=true&"
import script from "./Zwembaden.vue?vue&type=script&lang=js&"
export * from "./Zwembaden.vue?vue&type=script&lang=js&"
import style0 from "./Zwembaden.vue?vue&type=style&index=0&id=92773164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92773164",
  null
  
)

export default component.exports